import NavigationEnum from 'common/navigation';
import PageNotFound from 'components/widgets/error/page-not-found';
import Maintainance from 'components/widgets/maintenance/page-maintenance';
import regex from 'constant/regex';
import { useRouter } from 'next/router';
import React from 'react';

import DefaultLayout, { DefaultLayoutProps } from './default-layout';

export { default as DefaultLayout } from './default-layout';

export const publicnessRoute: Record<NavigationEnum, boolean> = {
  [NavigationEnum.aboutUs]: true,
  [NavigationEnum.checkBookingList]: false,
  [NavigationEnum.forgotPassword]: true,
  [NavigationEnum.guestAddPassenger]: false,
  [NavigationEnum.guestAddVehicle]: false,
  [NavigationEnum.guestList]: false,
  [NavigationEnum.guestPassengerList]: false,
  [NavigationEnum.guestVehicleList]: false,
  [NavigationEnum.home]: true,
  [NavigationEnum.login]: true,
  [NavigationEnum.maintenance]: true,
  [NavigationEnum.notFound]: true,
  [NavigationEnum.profile]: false,
  [NavigationEnum.refund]: false,
  [NavigationEnum.register]: true,
  [NavigationEnum.reschedule]: false,
  [NavigationEnum.searchShipping]: true,
  [NavigationEnum.shippingAddons]: true,
  [NavigationEnum.shippingDetail]: false,
  [NavigationEnum.shippingPayment]: false,
  [NavigationEnum.termCondition]: true,
};

export default function Layout(props: { children: React.ReactNode }) {
  const { pathname, query } = useRouter();
  const defaultLayoutProps = React.useMemo<
    Omit<DefaultLayoutProps, 'children'>
  >(() => {
    switch (pathname as NavigationEnum) {
      case NavigationEnum.aboutUs:
        return {
          mainCss: {
            height: '100%',
          },
          isShowFooter: true,
        };
      case NavigationEnum.guestAddPassenger:
      case NavigationEnum.guestAddVehicle:
        return {
          isShowFooter: true,
        };
      case NavigationEnum.guestList:
      case NavigationEnum.guestPassengerList:
      case NavigationEnum.guestVehicleList:
      case NavigationEnum.searchShipping:
      case NavigationEnum.termCondition:
        return {
          isShowFooter: true,
          isShowFloatingButton: true,
        };
      case NavigationEnum.checkBookingList:
        return {};
      case NavigationEnum.shippingAddons:
        return {
          mainCss: {
            height: '100vh',
            overflowY: 'auto',
          },
        };
      case NavigationEnum.profile:
        return {
          mainCss: { flex: 1 },
        };
      case NavigationEnum.shippingDetail:
      case NavigationEnum.shippingPayment:
      case NavigationEnum.reschedule:
      case NavigationEnum.refund:
      case NavigationEnum.home:
        return {
          isShowBottomSheet: true,
          isShowFloatingButton: true,
          isShowFooter: true,
        };

      case NavigationEnum.maintenance:
      case NavigationEnum.register:
      case NavigationEnum.notFound:
      case NavigationEnum.login:
      case NavigationEnum.forgotPassword:
      default:
        return {};
    }
  }, [pathname]);

  const id = query.id as string | undefined;

  const isValidRoute = React.useMemo(() => {
    switch (pathname as NavigationEnum) {
      case NavigationEnum.refund:
      case NavigationEnum.reschedule:
      case NavigationEnum.guestPassengerList:
      case NavigationEnum.guestVehicleList:
      case NavigationEnum.shippingPayment:
      case NavigationEnum.shippingDetail:
        return regex.uuid.test(id || '');
      default:
        return true;
    }
  }, [id, pathname]);

  if (
    new Date() >= new Date('2025-02-13T06:50:00.000Z') &&
    new Date() <= new Date('2025-02-13T07:30:00.000Z')
  ) {
    return <Maintainance />;
  }

  switch (pathname as NavigationEnum) {
    case NavigationEnum.maintenance:
    case NavigationEnum.notFound:
      return props.children;
    default:
      return (
        <DefaultLayout
          {...defaultLayoutProps}
          children={isValidRoute ? props.children : <PageNotFound />}
        />
      );
  }
}
